import { AssetOCPPDiagnosticsApi } from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const assetOcppDiagnosticsApi = new AssetOCPPDiagnosticsApi(config);

export const assetDiagnosticsRequestInit = { credentials: 'include' as const };
